import { InlineText1 } from '@cian/ui-kit/typography';

import { clsx } from 'clsx';
import { FC } from 'react';

import { IAmenity } from './types';

const styles = require('./Amenity.css');

export const Amenity: FC<IAmenity> = props => {
  const { title, className, color, icon } = props;

  return (
    <div className={clsx(styles['root'], className)}>
      <span className={styles['icon']}>{icon}</span>
      <InlineText1 color={color}>{title}</InlineText1>
    </div>
  );
};

Amenity.displayName = 'Amenity';
